// This one is in camelcase because it's not a class
// Everything in here will get loaded, so disable what's unnecessary
export default [
    // {
    //     name: 'environmentMapTexture',
    //     type: 'cubeTexture',
    //     path: [
    //         'textures/environmentMap/px.jpg',
    //         'textures/environmentMap/nx.jpg',
    //         'textures/environmentMap/py.jpg',
    //         'textures/environmentMap/ny.jpg',
    //         'textures/environmentMap/pz.jpg',
    //         'textures/environmentMap/nz.jpg'
    //     ]
    // },
    // {
    //     name: 'foxModel',
    //     type: 'gltfModel',
    //     path: 'models/Fox/glTF/Fox.gltf'
    // },
    {
        name: 'mapModel',
        type: 'gltfModel',
        // path: 'models/Map/glTF-Draco/Worldmap.glb'
        // path: 'models/Map/glTF-Draco/Map-proper.glb'
        path: `models/Map/glTF-Draco/Bezoekerscentrum_${__LOCALE__}.glb`
        // path: 'models/Map/glTF-Draco/Map-gigantic.glb'
        // path: 'models/Map/glTF-Draco/Map-placeholder.glb'
    },
    {
        name: 'skyModel',
        type: 'gltfModel',
        path: 'models/Sky/glTF/Sky.glb'
    },
    // {
    //     name: 'grassColorTexture',
    //     type: 'texture',
    //     path: 'textures/dirt/color.jpg'
    // },
    // {
    //     name: 'grassNormalTexture',
    //     type: 'texture',
    //     path: 'textures/dirt/normal.jpg'
    // },
    {
        name: 'fishModel',
        type: 'gltfModel',
        // path: 'models/Fish/glTF/Fish-animations-test.gltf'
        // path: 'models/Fish/glTF/Fish-animations.glb'
        // path: 'models/Fish/glTF/Fish-square-fix.glb'
        // path: 'models/Fish/glTF/Main-Fish.glb'
        path: 'models/Fish/glTF/Fish.glb'
    },
    {
        name: 'alosaModel',
        type: 'gltfModel',
        path: 'models/Alosa/glTF/Alosa.glb'
    },
    {
        name: 'salmonModel',
        type: 'gltfModel',
        path: 'models/Salmon/glTF/Salmon.glb'
    },
    {
        name: 'eelModel',
        type: 'gltfModel',
        path: 'models/Eel/glTF/Eel.glb'
    },
    {
        name: 'boatModel',
        type: 'gltfModel',
        path: 'models/Boat/glTF/Boat.glb'
    },
    {
        name: 'fishingBoatModel',
        type: 'gltfModel',
        path: 'models/FishingBoat/glTF/FishingBoat.glb'
    },
    {
        name: 'windmillsModel',
        type: 'gltfModel',
        path: 'models/Windmills/glTF/Windmills.glb'
    },
    {
        name: 'windmillModel',
        type: 'gltfModel',
        path: 'models/Windmill/glTF/Windmill.glb'
    },
    {
        name: 'kingfisherModel',
        type: 'gltfModel',
        path: 'models/Kingfisher/glTF/Kingfisher.glb'
    },
    {
        name: 'otterModel',
        type: 'gltfModel',
        path: 'models/Otter/glTF/Otter.glb'
    },
    {
        name: 'dragonflyModel',
        type: 'gltfModel',
        path: 'models/Dragonfly/glTF/Dragonfly.glb'
    },
    {
        name: 'treeModel',
        type: 'gltfModel',
        path: 'models/Tree/glTF/LQ-Tree.glb'
    },
    {
        name: 'poplarModel',
        type: 'gltfModel',
        path: 'models/Poplar/glTF/LQ-Poplar.glb'
    },
    // {
    //     name: 'flowersModel',
    //     type: 'gltfModel',
    //     path: 'models/Flowers/glTF/Flower_material.glb'
    // },
    {
        name: 'flowersModelSimple',
        type: 'gltfModel',
        path: 'models/Flowers/glTF/FlowerSimpleMax.glb'
    },
    {
        name: 'wallsModel',
        type: 'gltfModel',
        path: 'models/Walls/glTF/Walls.glb'
    },
    // This one is dynamically set
    // {
    //     name: 'wallsTexture',
    //     type: 'texture',
    //     path: 'models/Walls/glTF/Textures/texture.webp'
    // },
    {
        name: 'wallsTextureSimple',
        type: 'texture',
        path: 'models/Walls/glTF/Textures/textureSimple.jpg'
    },
    {
        name: 'wallsOuterModel',
        type: 'gltfModel',
        path: 'models/WallsOuter/glTF/WallsOuter.glb'
    },
    // This one is dynamically set
    // {
    //     name: 'wallsTexture',
    //     type: 'texture',
    //     path: 'models/Walls/glTF/Textures/texture.webp'
    // },
    {
        name: 'wallsOuterTextureSimple',
        type: 'texture',
        path: 'models/WallsOuter/glTF/Textures/textureSimple.jpg'
    }
]